import { configureStore } from '@reduxjs/toolkit';
import editorReducer from './editorSlice';
import canvasObjectReducer from "./canvasObjectSlice";
import designPreviewReducer from "./designPreviewSlice";
import designReducer from "./designSlice";
import authReducer from "./features/auth/authSlice";
import cartReducer from "./cartSlice";
import wishlistReducer from "./wishlistSlice";
import ordersReducer from "./ordersSlice";
import featureFlagsReducer from "./features/featureFlags/featureFlagsSlice";
import dashboardReducer from "./features/dashboard/dashboardSlice";
import { listingWizardReducer } from "./features/listingWizard";

export const store = configureStore({
  reducer: {
    auth: authReducer, // 🔐 Authentication
    editor: editorReducer,
    canvasObject: canvasObjectReducer,
    designPreview: designPreviewReducer,
    designs: designReducer, // 🆕 Design persistence slice
    cart: cartReducer, // 🛒 Cart management
    wishlist: wishlistReducer, // ❤️ Wishlist (saved items)
    orders: ordersReducer, // 📦 Orders management
    featureFlags: featureFlagsReducer, // 🚩 Feature flags
    listingWizard: listingWizardReducer, // 🎨 Listing wizard (onboarding)
    ...dashboardReducer, // 🏢 Dashboard management (products & orders)
  },

  devTools: process.env.NODE_ENV !== 'production',
});

// Types for use throughout your app
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

